<template>
  <div id="page">
    <div align="center" style="margin-top: 48px">
      <div>
        <img
          src="static/xiangyangDIY/img_order_result.png"
          width="96px"
          height="72px"
        />
      </div>
      <div style="margin-top: 8px">
        <label>上传图片正在审核中</label>
      </div>
      <div style="margin-top: 8px">
        <label>我们将在24小时内完成审核</label>
      </div>
      <div style="margin-top: 8px">
        <label>此期间请不要申请新的卡片</label>
      </div>
      <div style="margin-top: 8px">
        <label>否则将有可能导致此次申请开卡失败</label>
      </div>
      <div style="margin-top: 48px; width: 96px">
        <b-button block variant="danger" @click="goHomeHC()">完成</b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderResult_hongcheng",
  data() {
    return {
      orderNo: "",
    };
  },
  created() {},
  beforeRouteLeave(to, from, next) {
    console.log("beforeRouteLeave");
    console.log("to", to);
    console.log("from", from);
    next();
  },
  mounted: function () {
    this.orderNo = this.$route.params.orderNo;
    console.log("orderNo:" + this.orderNo);
    let count = this.$store.state.hongcheng.reuploadCount;
    console.log("reuploadCount:" + count);
    let entrance = sessionStorage.getItem("entrance");
    console.log("entrance:" + entrance);
    let storeStr = JSON.stringify(this.$store.state.hongcheng);
    console.log(storeStr);
  },
  destroyed: function () {
    this.clear();
  },
  methods: {
    goHomeHC() {
      this.$router.replace({ name: "Home_hongcheng" });
    },
    clear() {
      sessionStorage.clear();
    },
    toHomeHC: function () {
      let entrance = sessionStorage.getItem("entrance");
      console.log("entrance--->", entrance);
      let count = this.$store.state.hongcheng.reuploadCount;
      console.log("count--->", count);
      let isReupload = count > 0;
      if (entrance == 1) {
        // 申请卡面入口
        if (isReupload) {
          let backCount = count * 2 - 1 + 3;
          console.log("backCount:" + backCount);
          this.$router.go(-backCount);
        } else {
          this.$router.go(-2);
        }
      } else if (entrance == 2) {
        // 查询进度入口
        if (isReupload) {
          let backCount = count * 2 - 1 + 2;
          console.log("backCount:" + backCount);
          this.$router.go(-backCount);
        } else {
          this.$router.go(-1);
        }
      } else {
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/hongcheng/OrderResult_hongcheng.vue